import { createSlice } from '@reduxjs/toolkit'
export const qcSlice = createSlice({
  name: 'qc',
  initialState: {
    selectedIdOutcome: null,
    selectedQty: 1,
    isEdit: false,
    idQualityCheck: null,
    boxBarcode: null,
    backFromDefect: false
  },
  reducers: {
    setSelectedIdOutcome: (state, action) => {
      state.selectedIdOutcome = action.payload.selectedIdOutcome;
    },
    setIsEdit: (state, action) => {
      state.isEdit = action.payload.isEdit;
    },
    setIdQualityCheck: (state, action) => {
      state.idQualityCheck = action.payload.idQualityCheck;
    },
    setBoxBarcode: (state, action) => {
      state.boxBarcode = action.payload.boxBarcode;
    },
    setSelectedQty: (state, action) => {
      state.selectedQty = action.payload.selectedQty;
    },
    setBackFromDefect: (state, action) => {
      state.backFromDefect = action.payload.backFromDefect;
    },
    setEmptyQC: (state, action) => {
      state.idQualityCheck = null;
      state.isEdit = false;
      state.selectedIdOutcome = null;
      state.boxBarcode = null;
      state.selectedQty = 1;
      state.backFromDefect = false;
    },
  },
})

// Action creators are generated for each case reducer function
export const { setSelectedIdOutcome, setIsEdit, setIdQualityCheck, setBoxBarcode, setSelectedQty, setEmptyQC, setBackFromDefect } = qcSlice.actions

export default qcSlice.reducer